import type { TealiumSettings } from './types';

/**
 * Tealium CDN origin. The documentation requires the absolute https origin —
 * protocol-relative URLs are not allowed.
 */
export const TEALIUM_CDN_ORIGIN = 'https://tags.tiqcdn.com';

/**
 * Tealium iQ platform origins used beyond the CDN libraries:
 * - `my.tealiumiq.com` — Web Companion / Tealium Tools UI assets
 * - `collect.tealiumiq.com` — Collect tracking pixels and events
 */
export const TEALIUM_IQ_ORIGINS = ['https://my.tealiumiq.com', 'https://collect.tealiumiq.com'] as const;

export type TealiumLibraryFile = 'utag.js' | 'utag.sync.js';

/**
 * Build the URL of a Tealium library file for the given account/profile/environment:
 * `https://tags.tiqcdn.com/utag/{account}/{profile}/{environment}/{file}`
 */
export function buildUtagUrl(settings: TealiumSettings, file: TealiumLibraryFile): string {
    const { account, profile, environment } = settings;
    return `${TEALIUM_CDN_ORIGIN}/utag/${account}/${profile}/${environment}/${file}`;
}
